import dayjs from "dayjs";
import { ErrorCode } from "./types";
import type { BabyLoanRequest } from "./types";

export function getKOs(data: BabyLoanRequest): ErrorCode[] {
	// Hibák
	const errors: number[] = [];

	const age = dayjs().diff(data.birthDate, "year");

	if (age < 18) {
		errors.push(ErrorCode.AGE);
	}

	if (age > 34) {
		errors.push(ErrorCode.AGE);
	}

	if (!data.married) {
		errors.push(ErrorCode.MARRIED);
	}

	if (!data.hasBothOfTheCoupleHunAddress) {
		errors.push(ErrorCode.ADDRESS);
	}

	if (data.hasEitherOfCoupleNavDebt) {
		errors.push(ErrorCode.NAV);
	}

	if (data.inKHR) {
		errors.push(ErrorCode.KHR);
	}

	if (!data.isLast180daysSocInHun) {
		errors.push(ErrorCode.DAYSSOCINHUN);
	}

	if (
		data.hasEitherOfCoupleSocialInsurance === "LESS_THAN_THREE" ||
		data.hasEitherOfCoupleSocialInsurance === "NONE"
	) {
		errors.push(ErrorCode.SOC);
	}

	return errors;
}
